//@flow

import env from '../../environment';
import {postCreator, deleteCreator, putCreator, getCreator} from '../../http';

export const endpoints = Object.freeze({
  LIST_CHATBOTS: `${env.baseApiUrl}/winehouse/admin/crm/chatbot`,
  CREATE_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot`,
  DELETE_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId`,
  EDIT_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId`,
  GET_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId`,

  TRAIN_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId/train`,
  GET_TRAINING: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId/training`,
  DELETE_TRAINING: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/training/:trainingId`,
});

export const listChatbotsApi = getCreator(endpoints.LIST_CHATBOTS);
export const createChatbotApi = postCreator(endpoints.CREATE_CHATBOT);
export const deleteChatbotApi = deleteCreator(endpoints.DELETE_CHATBOT);
export const editChatbotApi = putCreator(endpoints.EDIT_CHATBOT);
export const getChatbotApi = getCreator(endpoints.GET_CHATBOT);

export const trainChatbotApi = postCreator(endpoints.TRAIN_CHATBOT);
export const getTrainingApi = getCreator(endpoints.GET_TRAINING);
export const deleteTrainingApi = deleteCreator(endpoints.DELETE_TRAINING);
